export default "__VITE_ASSET__CS$iThBV__"